<template>
  <div class="register" style="height: 100%; padding-bottom: 4rem">
    <a @click="$router.go(-1)" class="cursor-pointer" title="Go back">
      <v-icon large>arrow_back</v-icon>
    </a>
    <v-form style="position: relative" ref="form">
      <v-card max-width="500" class="mx-auto">
        <v-app-bar dark color="primary">
          <v-toolbar-title v-translate>Login</v-toolbar-title>
        </v-app-bar>
        <div class="pt-1 pl-3">
          <ErrorMessages :error="error">
            <template>
              {{ error }}
              <router-link
                to="/auth/registerUser"
                class="d-inline-block"
                style="white-space: nowrap"
                v-if="error.includes(`couldn't find an account with`)"
                >Please Register</router-link
              >
            </template>
          </ErrorMessages>
        </div>
        <v-container class="pa-3 pt-1 pb-0" fluid grid-list-md>
          <v-layout>
            <v-flex sm12>
              <v-text-field
                v-model="email"
                :label="$gettext('Email') + '*'"
                required
                @input="inputEmail"
                :rules="[
                  (v) => !!v || 'This field is required',
                  (v) => $store.state.regexps.email.test(v) || 'This is not valid email',
                ]"
                @keydown.enter.prevent="submit"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                :type="showPass ? 'text' : 'password'"
                :label="$gettext('Password') + ' *'"
                v-model="password"
                :rules="[(v) => !!v || 'This field is required']"
                @click:append="showPass = !showPass"
                @keydown.enter.prevent="submit"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm12>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <ForgotPassword :dialog="dialog" :closeDialog="() => (dialog = false)" />
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions class="pb-6 px-6 login-actions">
          <v-btn text class="cursor-pointer px-0" @click="dialog = true">
            <translate>Forgot Password</translate>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> <translate>CANCEL</translate> </v-btn>&nbsp; &nbsp;
          <v-btn @click.prevent="submit" color="primary" :loading="loading">
            <translate>CONTINUE</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
      <div class="d-flex justify-center mt-3">
        <router-link :to="{ name: 'registerUser' }">
          <translate>Register</translate>
        </router-link>
      </div>
    </v-form>
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import ForgotPassword from '@/components/app/login/ForgotPassword'

export default {
  name: 'Login',

  components: {
    ForgotPassword,
  },

  data: () => ({
    email: '',
    password: '',
    showPass: false,
    from: null,
    dialog: false,
    error: '',
    loading: false,
  }),

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from
    })
  },

  methods: {
    inputEmail() {
      if (this.submitStatus) {
        this.submitStatus = ''
      }
    },
    async submit() {
      this.error = ''
      this.confirmError = false

      if (this.$refs.form.validate()) {
        this.loading = true
        await this.signIn(this.email, this.password)

        this.loading = false
      }
    },
    async signIn(username, password) {
      try {
        const user = await Auth.signIn(username, password)
        if (user && user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          // const { requiredAttributes } = user.challengeParam // the array of required attributes, e.g ['email', 'phone_number']
          Auth.completeNewPassword(
            user, // the Cognito User Object
            password, // the new password
            // OPTIONAL, the required attributes
            {
              email: username,
            },
          )
            .then(() => {
              AmplifyEventBus.$emit('authState', 'signedIn')
            })
            .catch((e) => {
              console.error(e)
              this.error = e
            })
        }
        if (user) {
          this.$store.dispatch('auth/signedIn')
          this.$store.dispatch('auth/getOrganization')
        }
      } catch (err) {
        this.loading = false
        if (err.code === 'UserNotConfirmedException') {
          this.confirmError = true
          this.error = "User didn't finish the confirmation step when signing up"
        } else if (err.code === 'PasswordResetRequiredException') {
          this.error = 'Password Reset is required'
        } else if (err.code === 'UserNotFoundException') {
          this.error = `Sorry, we couldn't find an account with that email address.`
        } else if (err.code === 'NotAuthorizedException') {
          this.error = 'Incorrect password is provided'
        } else {
          this.error = err
        }
      }
    },
  },
}
</script>

<style scoped>
.register {
  padding: 20px;
}

@media screen and (max-width: 600px) {
  .login-actions {
    flex-direction: column;
  }
}
</style>
